import React from 'react';
import { Popover, Title, Text, Button, ActionIcon } from "rizzui";
import { Trash } from "lucide-react";

function DeleteActionButton({ onConfirm, itemName = "user" }) {
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Popover>
        <Popover.Trigger>
          <ActionIcon variant="outline" rounded="md" size="sm" className="border-gray-200">
            <Trash className="w-4 h-4" />
          </ActionIcon>
        </Popover.Trigger>
        <Popover.Content>
          {({ setOpen }) => (
            <div className="w-56">
              <Title as="h6">Delete {itemName}</Title>
              <Text>Are you sure you want to delete this {itemName}?</Text>
              <div className="flex justify-end gap-3 mb-1">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => setOpen(false)}
                >
                  No
                </Button>
                <Button
                  size="sm"
                  onClick={() => {
                    if (onConfirm) onConfirm();
                    setOpen(false);
                  }}
                >
                  Yes
                </Button>
              </div>
            </div>
          )}
        </Popover.Content>
      </Popover>
    </span>
  );
}

export default DeleteActionButton;
